import apiClient from 'apps/web/builder/utils/client';

export const logout = async (token?: string) => {
  const response = await apiClient.post('/auth/logout', {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
  return response.data;
};
